import { useEffect, useRef, useState } from "react";
import { Eraser, Eye, EyeOff } from "lucide-react";
import { SpeakButton } from "@/components/SpeakButton";

export const WritingPad = ({ char, hint, lang }) => {
  const canvas = useRef(null);
  const drawing = useRef(false);
  const [guide, setGuide] = useState(true);

  const clear = () => {
    const c = canvas.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
  };
  useEffect(clear, [char]);

  const pos = (e) => {
    const r = canvas.current.getBoundingClientRect();
    return [((e.clientX - r.left) / r.width) * canvas.current.width, ((e.clientY - r.top) / r.height) * canvas.current.height];
  };
  const down = (e) => {
    drawing.current = true;
    canvas.current.setPointerCapture(e.pointerId);
    const ctx = canvas.current.getContext("2d");
    ctx.beginPath();
    ctx.moveTo(...pos(e));
  };
  const move = (e) => {
    if (!drawing.current) return;
    const ctx = canvas.current.getContext("2d");
    ctx.lineWidth = 14;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#0f172a";
    ctx.lineTo(...pos(e));
    ctx.stroke();
  };

  return (
    <div data-testid="writing-pad" className="rounded-3xl bg-white border border-slate-200 p-5">
      <div className="flex items-center gap-3 mb-3">
        <div className="flex-1">
          <p className="font-display font-bold text-slate-900">Trace & write: <span className="text-2xl">{char}</span></p>
          {hint && <p className="text-xs text-slate-500">{hint}</p>}
        </div>
        <SpeakButton text={char} lang={lang} testId="writing-pad-speak" showSlow={false} />
      </div>
      <div className="relative mx-auto aspect-square w-full max-w-[280px] rounded-2xl bg-[hsl(var(--bg))] border-2 border-dashed border-slate-300 overflow-hidden">
        <div className="absolute inset-0 pointer-events-none" style={{ backgroundImage: "linear-gradient(#e2e8f0 1px, transparent 1px), linear-gradient(90deg, #e2e8f0 1px, transparent 1px)", backgroundSize: "50% 50%" }} />
        {guide && <span className="absolute inset-0 grid place-items-center text-[170px] leading-none text-slate-300/70 select-none pointer-events-none font-display">{char}</span>}
        <canvas
          ref={canvas}
          width={560}
          height={560}
          data-testid="writing-pad-canvas"
          onPointerDown={down}
          onPointerMove={move}
          onPointerUp={() => (drawing.current = false)}
          onPointerLeave={() => (drawing.current = false)}
          className="absolute inset-0 w-full h-full touch-none cursor-crosshair"
        />
      </div>
      <div className="flex gap-2 justify-center mt-3">
        <button data-testid="writing-pad-clear" onClick={clear} className="btn-ghost !py-2 !px-4 text-sm"><Eraser size={16} /> Clear</button>
        <button data-testid="writing-pad-guide-toggle" onClick={() => setGuide(!guide)} className="btn-ghost !py-2 !px-4 text-sm">
          {guide ? <EyeOff size={16} /> : <Eye size={16} />} {guide ? "Hide guide" : "Show guide"}
        </button>
      </div>
      <p className="text-xs text-slate-500 text-center mt-2">Trace with the guide first, then hide it and write from memory.</p>
    </div>
  );
};
